import { useFullLesson } from '../../lessons';
import { useFullShort } from '../../shortContent';
import { ACContentCardSmall } from 'academy-common-lib/components/card/ACContentCardSmall';
import ReducedCardSkeleton from '../../../components/Skeletons/ReducedCardSkeleton';
import getLang from 'academy-common-lib/utils/getLang';
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const InnerContentDisplayCard = ({
  containerId,
  containerType,
  innerContentId,
  relevantTimestamp,
  onClick
}) => {
  const {
    lesson,
    lessonLoading
  } = useFullLesson(containerId, getLang(), containerType !== 'LESSON');
  const {
    short,
    shortLoading
  } = useFullShort(containerId, containerType !== 'SHORT_FORM_CONTENT');
  const renderableContent = useMemo(() => {
    if (containerType === 'LESSON') {
      const foundContent = lesson === null || lesson === void 0 ? void 0 : lesson.content.find(content => content.id === innerContentId);
      if (!foundContent) return null;
      return {
        name: foundContent.name,
        thumbnailSrc: foundContent.previewThumbnailRectangleUrl || lesson.previewThumbnailRectangleUrl,
        duration: foundContent.duration
      };
    } else if (containerType === 'SHORT_FORM_CONTENT') {
      if (!short) return null;
      return {
        name: short.name,
        thumbnailSrc: short.previewThumbnailRectangleUrl,
        duration: short.duration
      };
    }
    return null;
  }, [lesson, short, innerContentId, containerType]);
  const relevantSectionMoment = relevantTimestamp ? I18n.moment.duration(relevantTimestamp) : undefined;
  const contentHref = useMemo(() => {
    if (containerType === 'LESSON') {
      return `/lessons/${containerId}/${innerContentId}?vts=${(relevantSectionMoment === null || relevantSectionMoment === void 0 ? void 0 : relevantSectionMoment.asSeconds()) || 0}`;
    } else if (containerType === 'SHORT_FORM_CONTENT') {
      return `/shortvideo/${containerId}?vts=${(relevantSectionMoment === null || relevantSectionMoment === void 0 ? void 0 : relevantSectionMoment.asSeconds()) || 0}`;
    }
  }, [containerId, containerType, relevantSectionMoment, innerContentId]);
  if (lessonLoading || shortLoading) return /*#__PURE__*/_jsx(ReducedCardSkeleton, {});
  if (!renderableContent) return null;
  return /*#__PURE__*/_jsx(ACContentCardSmall, {
    contentHref: contentHref,
    footer: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.aiSearch.video.relevantSectionAt",
      options: {
        time: I18n.moment.utc((relevantSectionMoment === null || relevantSectionMoment === void 0 ? void 0 : relevantSectionMoment.asMilliseconds()) || 0).format('mm:ss')
      }
    }),
    imageSrc: renderableContent.thumbnailSrc || undefined,
    length: renderableContent.duration || 0,
    lengthType: "time",
    linkMode: "react-router",
    name: renderableContent.name,
    onClick: onClick
  });
};
export default InnerContentDisplayCard;